import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { Package } from '../../../types/packager-types';
import { AppContext } from '../../../App';

// Single-package detail fetch. Mirrors useGetPackages conventions (gcTime 1h,
// staleTime 10m, array query key). Used by the completeness detail modal so it
// gets both `completeness` and the detail-only `validation` block from one source.
export const useGetPackage = (packageId?: string) => {
  const { dataPoolId } = useContext(AppContext);
  const glynt = useGlynt();

  return useQuery<Package>({
    queryKey: ['package', dataPoolId, packageId],
    queryFn: async () => await (await glynt).packages.getById(packageId!),
    enabled: !!packageId,
    refetchOnWindowFocus: false,

    // 1 hour
    gcTime: 1000 * 60 * 60,

    // 10 minutes
    staleTime: 1000 * 60 * 10,
  });
};
